import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recommendedBadge: {
    defaultMessage: 'Recommended',
    id: '6vj9Tn',
    description: 'Badge label on the seller recommendation popover card',
  },
  learnMore: {
    defaultMessage: 'Learn More',
    id: 'Ua+rDx',
    description: 'Learn more link label on the seller recommendation popover card',
  },
  close: {
    defaultMessage: 'Close recommendation',
    id: 'k7VpsD',
    description: 'Aria label for the close button on the seller recommendation popover card',
  },
});
